import Ajv from "ajv";

export type PricePayload = {
  productType: "MPI";
  coverageStartDate: string;
  coverageEndDate: string;
  limit?: number;
  isManulifeSvPricingLimits?: boolean;
};

export type MPIPriceResponse = {
  gp: number;
  levy: number;
  total: number;
};

export type MPIMultiLimitPriceResponse = Record<number, MPIPriceResponse>;

export const pricingResponseSchema = {
  type: "object",
  properties: {
    gp: {
      type: "number",
    },
    levy: {
      type: "number",
    },
    total: {
      type: "number",
    },
  },
  required: ["gp", "levy", "total"],
  additionalProperties: true,
};

export const validatePricingResponse = new Ajv().compile(pricingResponseSchema);

export const multiLimitPricingResponseSchema = {
  type: "object",
  additionalProperties: {
    type: "object",
    properties: {
      gp: { type: "number" },
      levy: { type: "number" },
      total: { type: "number" },
    },
    required: ["gp", "levy", "total"],
  },
};

export const validateMultiLimitPricingResponse = new Ajv().compile(multiLimitPricingResponseSchema);
